module.exports = __webpack_public_path__ + "media/images/athletes/1979-41f776c92d6501c2818a73174f6e067b.png";